<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />

      </b-col>
    </b-row>


    <b-row class="match-height" >
      <b-col
          xl="6"
          md="6"
          sm="12"
      >
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            pill
            to="/statistics/users/week"
        >
          مشاهده کاربران هفته گذشته
        </b-button>
      </b-col>
      <b-col
          xl="6"
          md="6"
          sm="12"
      >
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            pill
            to="/statistics/users/month"
        >
          مشاهده کاربران یک ماه گذشته
        </b-button>
      </b-col>
    </b-row>
    <b-row class="match-height" v-if="statistics">
      <b-col cols="12" class="my-1">
        <h2>
          آمار کاربران
        </h2>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <div class="card p-2 d-flex flex-column justify-content-center align-items-center">
          <div>
            <feather-icon
                icon="HomeIcon"
                size="28"
            />
          </div>
          <div class="my-1">
            کاربران 24 ساعت گذشته :
          </div>
          <div class="font-weight-bold">
            <strong>{{statistics.today_users.length}} </strong>
          </div>
        </div>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <div class="card p-2 d-flex flex-column justify-content-center align-items-center">
          <div>
            <feather-icon
                icon="HomeIcon"
                size="28"
            />
          </div>
          <div class="my-1">
            کاربران 7 روز گذشته :
          </div>
          <div class="font-weight-bold">
            <strong>{{statistics.week_users.length}} </strong>
          </div>
        </div>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <div class="card p-2 d-flex flex-column justify-content-center align-items-center">
          <div>
            <feather-icon
                icon="HomeIcon"
                size="28"
            />
          </div>
          <div class="my-1">
            کاربران 30 روز گذشته :
          </div>
          <div class="font-weight-bold">
            <strong>{{statistics.month_users.length}} </strong>
          </div>
        </div>
      </b-col>

    </b-row>
    <b-row class="match-height">
      <div>
        <h3>لیست کاربران 24 ساعت گذشته</h3>
      </div>
      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>نام و نام خانوادگی</b-th>
            <b-th>شماره موبایل</b-th>
            <b-th>وضعیت </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr  v-for="(today, index) in statistics.today_users" :key="today.id">
            <b-td>
              {{today.first_name}}

              {{today.last_name}}
            </b-td>
            <b-td>
              <b-badge variant="primary" v-if="today.mobile">
                {{  today.mobile.replace("+98","0") }}
              </b-badge>
            </b-td>
            <b-td>
              <span>
                <strong>تعداد کل درخواست :</strong>
                 <b-badge variant="primary" v-if="today.statistic_orders.length>0">
                    {{today.statistic_orders.length}}
                 </b-badge>
                    <b-badge v-else>
                    0
                 </b-badge>
              </span>
              <br/>
              <span>
                  <strong>تعداد کل درخواست  رزرو:</strong>
                 <b-badge variant="primary" v-if="today.statistic_transactions.length>0">
                    {{today.statistic_transactions.length}}
                 </b-badge>
                    <b-badge v-else>
                    0
                 </b-badge>
              </span>
              <br/>
              <div class="card" style="padding: 4px">
                <div>
                  <strong>وضعیت درخواست ها </strong>
                </div>
                <div v-for="(order,o) in today.statistic_orders" :key="o">
                  <div class="d-flex">
                    <strong>نوع درخواست :</strong>
                    <div v-if="order.orderable_type==space">
                      اقامتگاه
                    </div>
                    <div v-if="order.orderable_type==event">
                      تجربه
                    </div>
                    <div v-if="order.orderable_type==car">
                      ترانسفر
                    </div>
                    <div v-if="order.orderable_type==tour">
                      تور
                    </div>
                  </div>
                  <div>
                    <div class="d-flex">
                      <strong>وضعیت  :</strong>
                      <div>
                        <b-badge  variant="success"
                                  v-if="order.status=='paid'">
                          موفق
                        </b-badge>
                        <b-badge
                            v-else-if="order.status=='success'">
                          درگاه
                        </b-badge>
                        <b-badge    variant="danger"
                                    v-else>
                          ناموفق/تست
                        </b-badge>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="d-flex">
                      <strong>تاریخ  :</strong>
                      <div>
                        {{
                          new Date(order.created_at).toLocaleString("fa-IR", {
                            timeZone: "Iran",
                          })
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card" style="padding: 4px">
                <div>
                  <strong>وضعیت رزروها </strong>
                </div>
                <div v-for="(transaction,t) in today.statistic_transactions" :key="t">
                  <div class="d-flex">
                    <strong>نوع درخواست :</strong>
                    <div v-if="transaction.order.orderable_type==space">
                      اقامتگاه
                    </div>
                    <div v-if="transaction.order.orderable_type==event">
                      تجربه
                    </div>
                    <div v-if="transaction.order.orderable_type==car">
                      ترانسفر
                    </div>
                    <div v-if="transaction.order.orderable_type==tour">
                      تور
                    </div>
                  </div>
                  <div>
                    <div class="d-flex">
                      <strong>وضعیت  :</strong>
                      <div>
                        <b-badge  variant="success"
                                  v-if="transaction.status=='success'">
                          موفق
                        </b-badge>
                        <b-badge    variant="danger"
                                    v-else>
                          ناموفق
                        </b-badge>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="d-flex">
                      <strong>تاریخ  :</strong>
                      <div>
                        {{
                          new Date(transaction.created_at).toLocaleString("fa-IR", {
                            timeZone: "Iran",
                          })
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

    </b-row>



  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio, BTableSimple, BThead, BTr, BTh, BTbody, BTd, BBadge,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";


export default {
  computed: {

  },
  components: {
    BBadge,
    BTd,
    BTbody,
    BTh,
    BTr,
    BThead,
    BTableSimple,
    StatisticCardVertical,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio
  },
  data() {
    return {

      space: "App\\Models\\Residence",
      tour: "App\\Models\\Tour",
      car: "App\\Models\\Car",
      event: "App\\Models\\Experience",
      perPage: 10,
      page: 1,
      statistics: [],
      residences: null,
      cars: null,
      tours: null,
      experiences: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      countryInput: {
        name: "",
        slug:"",
        status:"active"

      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.getStatistics();
  },

  methods: {

    async getStatistics() {
      this.cancelToken = this.$http.CancelToken.source();
      const requestData = {
        method: "get",
        url: "/admin/statistics/users",

      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.statistics = data.data;
            console.log(this.statistics)
          })
          .catch((err) => {
            console.log(err);
          });
    },




  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
